__turbopack_context__.v({
  "backgroundVideo": "bento-square-module-scss-module__Fn78IW__backgroundVideo",
  "boxOne": "bento-square-module-scss-module__Fn78IW__boxOne",
  "boxOneContent": "bento-square-module-scss-module__Fn78IW__boxOneContent",
  "boxOneCopy": "bento-square-module-scss-module__Fn78IW__boxOneCopy",
  "boxOneImage": "bento-square-module-scss-module__Fn78IW__boxOneImage",
  "buttons": "bento-square-module-scss-module__Fn78IW__buttons",
  "copyImage": "bento-square-module-scss-module__Fn78IW__copyImage",
  "heading": "bento-square-module-scss-module__Fn78IW__heading",
  "headinggradient": "bento-square-module-scss-module__Fn78IW__headinggradient",
  "image": "bento-square-module-scss-module__Fn78IW__image",
  "imageContainer": "bento-square-module-scss-module__Fn78IW__imageContainer",
  "marketplace": "bento-square-module-scss-module__Fn78IW__marketplace",
  "marketplaceSpacer": "bento-square-module-scss-module__Fn78IW__marketplaceSpacer",
  "media": "bento-square-module-scss-module__Fn78IW__media",
  "subtitle": "bento-square-module-scss-module__Fn78IW__subtitle",
  "vertical": "bento-square-module-scss-module__Fn78IW__vertical",
  "videoContainer": "bento-square-module-scss-module__Fn78IW__videoContainer",
});
